import { render } from "./FaqComp.vue?vue&type=template&id=d48d6e66&scoped=true"
import script from "./FaqComp.vue?vue&type=script&lang=js"
export * from "./FaqComp.vue?vue&type=script&lang=js"

import "./FaqComp.vue?vue&type=style&index=0&id=d48d6e66&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d48d6e66"]])

export default __exports__